import {
  ADD_UNSCRAMBLED_PARAGRAPHS_TO_LIST,
  ARE_MICROTRANSACTIONS_ENABLED,
  CLOSE_ALL_INLINE_QUIZZES,
  EDIT_JSON_NOTIFICATION,
  EDIT_JSON_NOTIFICATION_V2,
  EXERCISE_CHANGES_TO_PROCESS,
  FORCE_CHECK_ACHIEVEMENT,
  FORCE_HIGHLIGHT_PARAGRAPHS,
  FORCE_RESUME_VIDEO,
  FORCE_SHOW_SCRAMBLED_NOTIFICATION,
  IS_CUE_CHANGED,
  IS_DISCUSSION_BEING_DRAGGED,
  IS_MOBILE,
  IS_TOC_VISIBLE,
  IS_WELCOME_TO_NEW_LP_MODAL_SHOWN,
  MARK_SELECTED_CUE_ID,
  NOTIFY_PARAGRAPH_CHANGE,
  NOTIFY_TRANSCRIPT_CHANGE,
  NO_OF_DELIVERABLE_MODULES,
  PREV_AND_NEXT_MODULE_DATA,
  PREV_NUMBER_OF_LIVEBOOK_VIEWER,
  PREV_NUMBER_OF_TEXT_EDITOR,
  RECEIVE_COMMENT_NOTIF_EMAILS,
  RECEIVE_COMMENT_NOTIF_EMAILS_IMMEDIATELY,
  REMOVE_HEADER_NOTIFICATION,
  REMOVE_JSON_NOTIFICATION,
  REMOVE_JSON_NOTIFICATION_V2,
  REQUEST_CONSUMED,
  SET_ACTIVE_USER_GROUP,
  SET_ALLOW_PLAYBACK,
  SET_ALLOW_VIDEO_PAUSE,
  SET_ALL_SLUGS,
  SET_ARE_ALL_PARAGRAPHS_ALREADY_UNSCRAMBLED,
  SET_ARE_CC_ENABLED,
  SET_CALENDAR_EVENTS,
  SET_CAN_VIDEO_BE_PLAYED,
  SET_CHANGED_VIDEO_SRC,
  SET_CONSUMPTION_SCROLL_TO_PULSATING,
  SET_COURSE_DETAILS,
  SET_COURSE_ID_DATA,
  SET_COURSE_SLUGS,
  SET_CUESPAN_TIMESTAMPS,
  SET_CUE_TRACK,
  SET_CURRENT_SPEED,
  SET_CURRENT_USER_SUBMISSION_STATUS,
  SET_DATA_FOR_VIDEO_SCREENSHOTS,
  SET_DELIVERABLE_DETAILS,
  SET_DELIVERABLE_REACHED_ACCESS,
  SET_DELIVERABLE_REACHED_ACCESS_REASON,
  SET_DISABLED_CUE_SRC_EDITING,
  SET_DISCUSSION_READY,
  SET_DISCUSSION_SETTINGS,
  SET_DISCUSSION_VISIBLE,
  SET_DISCUSSION_WIDTH,
  SET_FILTER_GROUP_TYPE,
  SET_FILTER_TEXT_GROUPS_MANAGER,
  SET_GROUPS_FOR_USER,
  SET_GROUPS_MANAGER_SESSION_ID,
  SET_HAS_STARTED_LP_SISTER_OFFERINGS,
  SET_HIGHLIGHT_WHOLE_PARAGRAPH,
  SET_INITIAL_CODE_LISTING_CONSUMPTION,
  SET_INITIAL_QUIZ_CONSUMPTION,
  SET_INITIAL_TRY_IT_YOURSELF_CONSUMPTION,
  SET_INLINE_QUIZ_EXPANDED_STATE,
  SET_IS_DELIVERABLES_COMPLETED,
  SET_IS_IDLE,
  SET_IS_INITIAL_ACTIVE_GROUP_SET,
  SET_IS_LOGGED_IN,
  SET_IS_MEAP,
  SET_IS_MENTOR_FOR_THIS_COURSE,
  SET_IS_TEXT_ONLY_EXERCISE_VISIBLE,
  SET_IS_TRANSCRIPT_READY,
  SET_IS_TRANSCRIPT_VISIBLE,
  SET_IS_VIDEO_CURRENTLY_PLAYING,
  SET_IS_VIDEO_FRAGMENT_FRAME_VISIBLE,
  SET_IS_VIDEO_READY,
  SET_IS_VIDEO_VISIBLE,
  SET_JSON_NOTIFICATION,
  SET_JSON_NOTIFICATION_V2,
  SET_LICENSE_TIER,
  SET_LIST_OF_PARAGRAPHS_TO_UNSCRAMBLE,
  SET_LV_VIEWER_TYPE,
  SET_MEDIA_ELEMENT,
  SET_MEDIA_ELEMENT_PROPERTIES,
  SET_MENTORUI_USER_DATA,
  SET_MODULE_ID,
  SET_MODULE_TYPE,
  SET_MSS,
  SET_NEW_CODE_LISTINGS_RAWDATA,
  SET_NEW_COLORPICKER_COLOR,
  SET_NEW_FILE_UPLOADS_RAWDATA,
  SET_NEW_IMAGES_RAWDATA,
  SET_NEW_LIVEBOOK_VIEWER_RAWDATA,
  SET_NEW_MODULE_NAME,
  SET_NEW_QUIZZES_RAWDATA,
  SET_NEW_TEXT_EDITOR_RAWDATA,
  SET_NEW_TRY_IT_YOURSELF_RAWDATA,
  SET_NEW_VIDEO_SCREENSHOTS_RAWDATA,
  SET_NUMBER_OF_LP_USERS,
  SET_NUMBER_OF_TOKENS,
  SET_OLD_LOADER_HIDDEN,
  SET_PARAGRAPH_FOR_LOCK_ICON_SHOW_INDEX,
  SET_PREV_SOURCE_USED_FOR_ON_CAN_PLAY,
  SET_PULSATING_BUTTON_TIMING_INFO,
  SET_QUIZ_ID_TO_SHOW,
  SET_RESET_MEDIA_QUIZ_RAW_DATA,
  SET_SCRAMBLED_VIDEO_DURATION,
  SET_SEARCH_TERMS,
  SET_SHOULD_CHECK_LOGIN_ON_BACKEND,
  SET_SHOULD_DISPLAY_USER_OPTIONS_INSTEAD_OF_DISCUSSIONS,
  SET_SHOULD_SHOW_ACHIEVEMENT_SCREEN,
  SET_SHOULD_SHOW_PREVIEW_OF_EXERCISE_FOR_CERT_TEST,
  SET_SISTER_LICENSES_START_DATE,
  SET_SISTER_OFFERINGS,
  SET_SKILL_DOMAIN_POOL,
  SET_TEMP_DISABLED_EXERCISE_EDITING,
  SET_TOGGLE_TEXT_STATUS_NEW_CUE,
  SET_TOKEN_UNLOACKED_STATUS,
  SET_UNSCRAMBLED_VIDEO_FRAGMENT_DATA,
  SET_USERS_SISTER_LICENSES,
  SET_USER_CERTIFICATE_TEST_RESULTS,
  SET_USER_EXERCISES_RESULTS,
  SET_USER_HAS_ACCESS,
  SET_USER_HAS_ACCESS_TO_COURSE,
  SET_USER_HAS_ALL_DELIVERABLES_APPROVED,
  SET_USER_HAS_CERTIFICATE_FOR_COURSE,
  SET_USER_HAS_INVISIBLE_MODULE_ACCESS,
  SET_USER_HAS_PASSED_TEST,
  SET_USER_PROGRESS_REDUX,
  SET_USER_SUBMISSIONS,
  SET_VIDEO_DURATION,
  SET_WERE_GROUPS_FOR_USER_PREPARED,
  SET_WILL_PAGE_BE_RELOADED,
  SET_WINDOW_VISIBILITY,
  SHOULD_REDIRECT_TO_PROFILE,
  SHOW_HEADER_NOTIFICATION,
  SHOW_PROFILE_MODAL,
} from '../../constants';

import PlatformUtils from '../../adapters/PlatformUtils';
import { fromJS } from 'immutable';
import {
  onlyUnique
} from '../../api/common';

let discussionsWidth:any = localStorage.getItem("discussionsWidth");
if(discussionsWidth == null || isNaN((Number(discussionsWidth))) ){
  discussionsWidth = 300;
} else if(Number(discussionsWidth) < 100){
  discussionsWidth = 100;
}
else{
  discussionsWidth = Math.floor(Number(discussionsWidth));
}
if(isNaN(discussionsWidth) || isNaN((Number(discussionsWidth)))){
  discussionsWidth = 300;
}

const INITIAL_STATE = fromJS({
  videoTimingInformation: {
    mediaElement: null,
    videoDuration: 0,
    currentTime: 0,
    cueTrack: '',
    currentCueTopOffset: 0,
    numberOfRectsForCurrentOffset: 0,
    causedByResize: false,
    colorPickerColor: { r: '0', g: '0', b: '255', a: '1', },
    isTextOnlyExerciseVisible: false,
    isTocVisible: false,
    discussionsVisible: false,
    discussionsReady: false,
    disabledCueSrcEditing: false,
    inlineQuizExpandedState: [],
    areMicrotransactionsEnabled: false,
    basicGroupsSelectedFilter: true,
    premiumGroupsSelectedFilter: true,
    discussionsWidth: discussionsWidth,
    calendarEvents: [],
    pageWillBeReloaded: false,
    shouldForceOpenProfile: false,
    selectedSessionId: -9999,
    isIdle: false,
    windowVisibility: 'visible',
    isVideoCurrentlyPlaying: false,
  }

});



function inputTimeReducer(state = INITIAL_STATE, action =
  {
    type: '', mediaElement: null, prevSourceUsedForOnCanPlay: null, hour: 0, minute: 0, second: 0, duration: 0, currentTime: 0, cueTrack: '', currentCueTopOffset: 0,
    numberOfRectsForCurrentOffset: 0, causedByResize: false, forceCueTrackReload: false,
    mediaElementSrc: '', mediaElementSignedSrc: '', mediaElementSignedSrcDateChanged: null, mediaElementSubtitle: '', mediaElementSignedSubtitleSrc: '',
    quizConsumptionData: [], codeListingConsumptionData: [], tryItYourselfConsumptionData: [],
    ConsumptionKey: null,
    mediaElementQuizRawData: [],
    mediaElementImagesRawData: [],
    mediaElementVideoScreenshotsRawData: [],
    mediaElementFileUploadsRawData: [],
    mediaElementCodeListingsRawData: [],
    mediaElementTryItYourSelfRawData: [],
    mediaElementTextEditorRawData: [],
    mediaElementLiveBookViewerRawData: [],
    isMobileVariable: false, isCueChanged: false,
    quizId: -1, toggleTextXR: 50, toggleTextXL: 50, toggleTextStatus: 1,
    pulsatingButtonTimingInfo: -1, isScrollToPulsatingConsumed: true,
    dataForVideoScreenshots: {},
    prevNumberTextEditor: 0, prevNumberLiveBookViewer: 0, colorPickerColor: {}, prevModuleName: null, prevModuleRoute: null, nextModuleName: null, nextModuleRoute: null,
    courseDetails: {}, courseSlugs: {}, allSlugs: {},
    allowVideoPauseCL: true, allowVideoPauseEX: true,
    higlightWholeParagraph: false, higlightDisabled: false, higlightCurrentPhrase: true,
    discussions_code_of_conduct_shown: false, discussions_email_notifications_offered: false, discussions_offered: true,
    discussionsVisible: false,
    forceDiscussionsVisibility: false,
    discussionsReady: false, discussionsWidth: 300,
    calendarEvents: [],
    isDiscussionsBeingDraggedValue: false,
    exerciseChangesToProcess: null, toForceResumeVideo: false, isVideoVisible: true, wasVideoPlaying: false, exerEditingDisabled: false, isLoggedIn: false, shouldCheckLoginOnBackendValue: false,
    shouldResetActualStartTimeTextEditor: false,
    shouldResetActualStartTimeLiveBookViewer: false,
    shouldResetActualStartTimeImages: false,
    shouldResetActualStartTimeCodeListings: false,
    shouldResetActualStartTimeTryItYourself: false,
    shouldResetActualStartTimeQuiz: false,
    shouldResetActualStartTimeVideoScreenshots: false,
    JSONnotification: "", UIDnotifRemove: null, EditedJSONnotification: null,
    JSONnotificationV2: "", UIDnotifRemoveV2: null, EditedJSONnotificationV2: null,
    allowAutoplay: false,
    receiveCommentNotificationEmails: false,
    JSONHeadernotification: "",
    userHasDownloadAccess: null,
    isTranscriptVisible: true,
    isVideoFragmentFrameVisible: null,
    canVideoBePlayed: true,
    currentSpeed: "1.0",
    searchTerms: [],
    cuespanTimestamps: null,
    forceHighlightParagraphs: false,
    mapAllParagraphsTimestamp: null,
    transcriptChangedNotification: null,
    unscrambledVideoFragmentData: null,
    availableCompedTokenCount: null,
    availablePurchasedTokenCount: null,
    availableFreeTokenCount: null,
    receiveImmediateCommentNotificationEmails: null,
    tokenUnlockedStatus: null,
    userHasAccessToCourse: null,
    scrambledVideoDuration: null,
    listOfParagraphsToUnscramble: null,
    paragraphForLockIconShowIndex: null,
    listOfUnscrambledParagraphs: [],
    forceShowScrambledNotificationBoolean: false,
    allParagraphsUnscrambled: false,
    oldLoaderMessage: null,
    oldLoaderHidden: false,
    selectedCueId: null,
    changedVideoSrc: null,
    isVideoReady: false,
    isTranscriptReady: false,
    isMEAP: false,
    newModuleName: null,
    moduleType: null,
    moduleId: null,
    lvViewerType: null,
    deliverableReachedAccess: null,
    deliverableReachedAccessReason: null,
    userExercisesResults: null,
    userCertificateTestResults: null,
    userHasPassedTest: null,
    userHasAllDeliverablesApproved: null,
    isTextOnlyExerciseVisible: null,
    isTocVisible: null,
    disabledCueSrcEditing: null,
    inlineQuizIdToToggle: null,
    areMicrotransactionsEnabled: null,
    mss: null,
    hasInvisibleModuleAccess: null,
    isResetMediaQuizRawData: null,
    userProgress: null,
    forceCheckAchievementBoolean: null,
    deliverableUserLink: null,
    groupsForUser: null,
    wereGroupsForUserPrepared: null,
    userSubmissions: null,
    mentorUIUserData: null,
    currentUserSubmissionStatus: null,
    activeUserGroup: null,
    isInitialActiveGroupSet: null,
    isMentorForThisCourse: null,
    deliverableDetails: null,
    filterGroupsText: null,
    selectedSessionId: null,
    isDeliverablesCompleted: null,
    areClosedCaptionsEnabled: false,
    licenseTier: null,
    basicGroupsSelectedFilter: null,
    premiumGroupsSelectedFilter: null,
    skillDomainPool: null,
    pageWillBeReloaded: false,
    isWelcomeToNewLpModalShown: null,
    shouldForceOpenProfile: null,
    callbackRedirectAfterProfile: null,
    showProfileModal: null,
    numberOfLpUsers: null,
    shouldShowPreviewOfExerciseForCertificateTest: null,
    shouldDisplayUserOptionsInsteadOfDiscussions: null,
    hasSisterLicensesStarted: null,
    sisterLicensesStartedDate: null,
    sisterLicenses: null,
    isIdle: null,
    windowVisibility: null,
    isVideoCurrentlyPlaying: null,
    courseIdData: null,
    usersSisterLicenses: null,
    userHasCertificateForCourse: null,
    noDeliverableModules: null,
  }) {


  switch (action.type) {

    case FORCE_RESUME_VIDEO:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          toForceResumeVideo: action.toForceResumeVideo,
        })),
      }));

    case EXERCISE_CHANGES_TO_PROCESS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          exerciseChangesToProcess: action.exerciseChangesToProcess,
        })),
      }));

    case SET_MEDIA_ELEMENT:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElement: action.mediaElement,
        })),
      }));


    case SET_PREV_SOURCE_USED_FOR_ON_CAN_PLAY:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          prevSourceUsedForOnCanPlay: action.prevSourceUsedForOnCanPlay,
        })),
      }));


    case SET_CUE_TRACK:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          cueTrack: action.cueTrack,
        })),
      }));

    case SET_CHANGED_VIDEO_SRC:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          changedVideoSrc: action.changedVideoSrc,
        })),
      }));

    case SET_SEARCH_TERMS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          searchTerms: action.searchTerms,
        })),
      }));

    case IS_MOBILE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isMobileVariable: action.isMobileVariable,
        })),
      }));

    case IS_CUE_CHANGED:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isCueChanged: action.isCueChanged,
        })),
      }));

    case MARK_SELECTED_CUE_ID:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          selectedCueId: action.selectedCueId,
        })),
      }));

    case SET_MEDIA_ELEMENT_PROPERTIES:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementSrc: action.mediaElementSrc,
          mediaElementSignedSrc: action.mediaElementSignedSrc,
          mediaElementSignedSrcDateChanged: action.mediaElementSignedSrcDateChanged,
          mediaElementSubtitle: action.mediaElementSubtitle,
          mediaElementSignedSubtitleSrc: action.mediaElementSignedSubtitleSrc,
          mediaElementQuizRawData: action.mediaElementQuizRawData,
          mediaElementImagesRawData: action.mediaElementImagesRawData,
          mediaElementVideoScreenshotsRawData: action.mediaElementVideoScreenshotsRawData,
          mediaElementCodeListingsRawData: action.mediaElementCodeListingsRawData,
          mediaElementTryItYourSelfRawData: action.mediaElementTryItYourSelfRawData,
          mediaElementTextEditorRawData: action.mediaElementTextEditorRawData,
          mediaElementLiveBookViewerRawData: action.mediaElementLiveBookViewerRawData,
          mediaElementFileUploadsRawData: action.mediaElementFileUploadsRawData,
          isVideoVisible: action.isVideoVisible,
        })),
      }));


    case SET_QUIZ_ID_TO_SHOW:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          quizId: action.quizId,
        })),
      }));


    case SET_INLINE_QUIZ_EXPANDED_STATE:
      {
        let prevList = [];
        if (state.get('videoTimingInformation').get('inlineQuizExpandedState') != null) {
          prevList = state.get('videoTimingInformation').get('inlineQuizExpandedState').toJS();
        }
        if (prevList.some(it => it.id == action.inlineQuizIdToToggle)) {
          prevList = prevList.map(it => {
            if (it.id == action.inlineQuizIdToToggle) {
              it.expanded = !it.expanded;
            }
            return it;
          })
        } else {
          prevList.push({
            id: action.inlineQuizIdToToggle,
            expanded: true,
          })
        }

        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            inlineQuizExpandedState: prevList,
          })),
        }));
      }

    case CLOSE_ALL_INLINE_QUIZZES:
      {
        let prevList = [];
        if (state.get('videoTimingInformation').get('inlineQuizExpandedState') != null) {
          prevList = state.get('videoTimingInformation').get('inlineQuizExpandedState').toJS();
        }
        prevList.map(it => it.expanded = false);

        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            inlineQuizExpandedState: prevList,
          })),
        }));
      }


    case SET_DISABLED_CUE_SRC_EDITING:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          disabledCueSrcEditing: action.disabledCueSrcEditing,
        })),
      }));

    case SET_IS_VIDEO_VISIBLE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isVideoVisible: action.isVideoVisible,
          wasVideoPlaying: action.wasVideoPlaying,
        })),
      }));

    case SET_TOGGLE_TEXT_STATUS_NEW_CUE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          toggleTextStatus: action.toggleTextStatus,
        })),
      }));

    case SET_SHOULD_CHECK_LOGIN_ON_BACKEND:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          shouldCheckLoginOnBackendValue: action.shouldCheckLoginOnBackendValue,
        })),
      }));

    case SET_IS_LOGGED_IN:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isLoggedIn: action.isLoggedIn,
          })),
        }));
      }

    case SET_PULSATING_BUTTON_TIMING_INFO:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          pulsatingButtonTimingInfo: action.pulsatingButtonTimingInfo,
        })),
      }));

    case SET_CONSUMPTION_SCROLL_TO_PULSATING:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isScrollToPulsatingConsumed: action.isScrollToPulsatingConsumed,
        })),
      }));

    case SET_TEMP_DISABLED_EXERCISE_EDITING:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          exerEditingDisabled: action.exerEditingDisabled,
          // consumed: false
        })),
      }));


    case REQUEST_CONSUMED:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          consumed: true
        })),
      }));

    case SET_VIDEO_DURATION:

      //if(!isConsumed)
      //{
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          videoDuration: action.duration,
        })),
      }));
    //}
    //else{
    //    return state;
    //}

    case SET_INITIAL_QUIZ_CONSUMPTION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          quizConsumptionData: action.quizConsumptionData,
        })),
      }));

    case SET_INITIAL_TRY_IT_YOURSELF_CONSUMPTION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          tryItYourselfConsumptionData: action.tryItYourselfConsumptionData,
        })),
      }));

    case SET_INITIAL_CODE_LISTING_CONSUMPTION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          codeListingConsumptionData: action.codeListingConsumptionData,
        })),
      }));

    case SET_CUESPAN_TIMESTAMPS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          cuespanTimestamps: action.cuespanTimestamps,
        })),
      }));

    case SET_DATA_FOR_VIDEO_SCREENSHOTS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          dataForVideoScreenshots: action.dataForVideoScreenshots,
        })),
      }));


    case SET_NEW_QUIZZES_RAWDATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementQuizRawData: action.mediaElementQuizRawData,
        })),
      }));

    case SET_RESET_MEDIA_QUIZ_RAW_DATA:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isResetMediaQuizRawData: action.isResetMediaQuizRawData,
          })),
        }));
      }


    case SET_NEW_IMAGES_RAWDATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementImagesRawData: action.mediaElementImagesRawData,
        })),
      }));

    case SET_NEW_TEXT_EDITOR_RAWDATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementTextEditorRawData: action.mediaElementTextEditorRawData,
        })),
      }));

    case SET_NEW_LIVEBOOK_VIEWER_RAWDATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementLiveBookViewerRawData: action.mediaElementLiveBookViewerRawData,
        })),
      }));

    case SET_NEW_CODE_LISTINGS_RAWDATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementCodeListingsRawData: action.mediaElementCodeListingsRawData,
        })),
      }));

    case SET_NEW_TRY_IT_YOURSELF_RAWDATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementTryItYourSelfRawData: action.mediaElementTryItYourSelfRawData,
        })),
      }));

    case SET_NEW_VIDEO_SCREENSHOTS_RAWDATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementVideoScreenshotsRawData: action.mediaElementVideoScreenshotsRawData,
        })),
      }));

    case SET_NEW_FILE_UPLOADS_RAWDATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          mediaElementFileUploadsRawData: action.mediaElementFileUploadsRawData,
        })),
      }));

    case PREV_NUMBER_OF_TEXT_EDITOR:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          prevNumberTextEditor: action.prevNumberTextEditor,
        })),
      }));

    case PREV_NUMBER_OF_LIVEBOOK_VIEWER:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          prevNumberLiveBookViewer: action.prevNumberLiveBookViewer,
        })),
      }));

    case SET_NEW_COLORPICKER_COLOR:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          colorPickerColor: action.colorPickerColor,
        })),
      }));

    case PREV_AND_NEXT_MODULE_DATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          prevModuleName: action.prevModuleName,
          prevModuleRoute: action.prevModuleRoute,
          nextModuleName: action.nextModuleName,
          nextModuleRoute: action.nextModuleRoute,
        })),
      }));

    case SET_IS_TRANSCRIPT_VISIBLE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isTranscriptVisible: action.isTranscriptVisible,
        })),
      }));

    case SET_IS_VIDEO_FRAGMENT_FRAME_VISIBLE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isVideoFragmentFrameVisible: action.isVideoFragmentFrameVisible,
        })),
      }));

    case SET_CAN_VIDEO_BE_PLAYED:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          canVideoBePlayed: action.canVideoBePlayed,
        })),
      }));

    case SET_COURSE_DETAILS:
      let shouldGenerateDate = state.get('videoTimingInformation').get("courseDetailsTimestamp") != null ? false : true;
      if (state.get('videoTimingInformation').get("courseDetails") != null) {
        if (JSON.stringify(state.get('videoTimingInformation').get("courseDetails").toJS()) !== JSON.stringify(action.courseDetails)) {
          shouldGenerateDate = true;
        }
      }
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          courseDetails: action.courseDetails,
          courseDetailsTimestamp: shouldGenerateDate ? new Date() : state.get('videoTimingInformation').get("courseDetailsTimestamp"),
        })),
      }));

    case SET_COURSE_SLUGS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          courseSlugs: action.courseSlugs,
        })),
      }));

    case SET_COURSE_ID_DATA:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          courseIdData: action.courseIdData,
        })),
      }));

    case SET_USERS_SISTER_LICENSES:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          usersSisterLicenses: action.usersSisterLicenses,
        })),
      }));

    case NO_OF_DELIVERABLE_MODULES:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          noDeliverableModules: action.noDeliverableModules,
        })),
      }));

    case SET_ALL_SLUGS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          allSlugs: action.allSlugs,
        })),
      }));


    //User options
    case SET_HIGHLIGHT_WHOLE_PARAGRAPH:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          higlightWholeParagraph: action.higlightWholeParagraph,
          higlightDisabled: action.higlightDisabled,
          higlightCurrentPhrase: action.higlightCurrentPhrase,
        })),
      }));

    case SET_DISCUSSION_SETTINGS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          discussions_code_of_conduct_shown: action.discussions_code_of_conduct_shown,
          discussions_email_notifications_offered: action.discussions_email_notifications_offered,
          discussions_offered: action.discussions_offered,
        })),
      }));

    case SET_ALLOW_VIDEO_PAUSE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          allowVideoPauseCL: action.allowVideoPauseCL,
          allowVideoPauseEX: action.allowVideoPauseEX,
        })),
      }));

    case SET_ALLOW_PLAYBACK:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          allowAutoplay: action.allowAutoplay,
        })),
      }));

    case SET_NUMBER_OF_TOKENS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          availableCompedTokenCount: action.availableCompedTokenCount,
          availablePurchasedTokenCount: action.availablePurchasedTokenCount,
          availableFreeTokenCount: action.availableFreeTokenCount,
        })),
      }));

    case SET_TOKEN_UNLOACKED_STATUS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          tokenUnlockedStatus: action.tokenUnlockedStatus,
        })),
      }));

    case SET_USER_HAS_ACCESS_TO_COURSE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          userHasAccessToCourse: action.userHasAccessToCourse,
        })),
      }));

    case SET_USER_HAS_CERTIFICATE_FOR_COURSE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          userHasCertificateForCourse: action.userHasCertificateForCourse,
        })),
      }));

    case SET_USER_HAS_INVISIBLE_MODULE_ACCESS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          hasInvisibleModuleAccess: action.hasInvisibleModuleAccess,
        })),
      }));

    case SET_JSON_NOTIFICATION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          JSONnotification: action.JSONnotification,
        })),
      }));

    case EDIT_JSON_NOTIFICATION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          EditedJSONnotification: action.EditedJSONnotification,
        })),
      }));

    case SET_CURRENT_SPEED:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          currentSpeed: action.currentSpeed,
        })),
      }));

    case RECEIVE_COMMENT_NOTIF_EMAILS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          receiveCommentNotificationEmails: action.receiveCommentNotificationEmails,
        })),
      }));

    case RECEIVE_COMMENT_NOTIF_EMAILS_IMMEDIATELY:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          receiveImmediateCommentNotificationEmails: action.receiveImmediateCommentNotificationEmails,
        })),
      }));

    case SET_IS_VIDEO_READY:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isVideoReady: action.isVideoReady,
        })),
      }));

    case SET_ARE_CC_ENABLED:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          areClosedCaptionsEnabled: action.areClosedCaptionsEnabled,
        })),
      }));

    case SET_IS_TEXT_ONLY_EXERCISE_VISIBLE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isTextOnlyExerciseVisible: action.isTextOnlyExerciseVisible,
        })),
      }));

    case SET_IS_TRANSCRIPT_READY:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          isTranscriptReady: action.isTranscriptReady,
        })),
      }));

    case REMOVE_JSON_NOTIFICATION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          UIDnotifRemove: action.UIDnotifRemove,
        })),
      }));

    case SET_JSON_NOTIFICATION_V2:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          JSONnotificationV2: action.JSONnotificationV2,
        })),
      }));

    case EDIT_JSON_NOTIFICATION_V2:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          EditedJSONnotificationV2: action.EditedJSONnotificationV2,
        })),
      }));

    case REMOVE_JSON_NOTIFICATION_V2:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          UIDnotifRemoveV2: action.UIDnotifRemoveV2,
        })),
      }));

    case SHOW_HEADER_NOTIFICATION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          JSONHeadernotification: action.JSONHeadernotification,
        })),
      }));

    case REMOVE_HEADER_NOTIFICATION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          JSONHeadernotification: null,
        })),
      }));


    case SET_USER_HAS_ACCESS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          userHasDownloadAccess: action.userHasDownloadAccess,
        })),
      }));


    case FORCE_HIGHLIGHT_PARAGRAPHS:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          forceHighlightParagraphs: action.forceHighlightParagraphs,
        })),
      }));

    case NOTIFY_PARAGRAPH_CHANGE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            mapAllParagraphsTimestamp: action.mapAllParagraphsTimestamp,
          })),
        }));
      }

    case NOTIFY_TRANSCRIPT_CHANGE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            transcriptChangedNotification: action.transcriptChangedNotification,
          })),
        }));
      }

    case SET_UNSCRAMBLED_VIDEO_FRAGMENT_DATA:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            unscrambledVideoFragmentData: action.unscrambledVideoFragmentData,
          })),
        }));
      }

    case SET_SCRAMBLED_VIDEO_DURATION:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            scrambledVideoDuration: action.scrambledVideoDuration,
          })),
        }));
      }

    case SET_ARE_ALL_PARAGRAPHS_ALREADY_UNSCRAMBLED:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            allParagraphsUnscrambled: action.allParagraphsUnscrambled,
          })),
        }));
      }

    case SET_LIST_OF_PARAGRAPHS_TO_UNSCRAMBLE:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          listOfParagraphsToUnscramble: action.listOfParagraphsToUnscramble,
        })),
      }));

    case SET_PARAGRAPH_FOR_LOCK_ICON_SHOW_INDEX:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          paragraphForLockIconShowIndex: action.paragraphForLockIconShowIndex,
        })),
      }));

    case ADD_UNSCRAMBLED_PARAGRAPHS_TO_LIST:
      let previousList = [];
      if (state.get('videoTimingInformation').get('listOfUnscrambledParagraphs') != null) {
        previousList = state.get('videoTimingInformation').get('listOfUnscrambledParagraphs').toJS();
      }
      let newList = [...previousList, ...action.listOfUnscrambledParagraphs].filter(onlyUnique).sort(function (a, b) { return a - b; });
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          listOfUnscrambledParagraphs: newList,
        })),
      }));

    case FORCE_SHOW_SCRAMBLED_NOTIFICATION:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          forceShowScrambledNotificationBoolean: action.forceShowScrambledNotificationBoolean,
        })),
      }));

    case SET_OLD_LOADER_HIDDEN:
      return state.merge(fromJS({
        videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
          oldLoaderHidden: { value: action.oldLoaderHidden, date: Date() },
          oldLoaderMessage: action.oldLoaderMessage,
        })),
      }));

    case SET_IS_MEAP:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isMEAP: action.isMEAP,
          })),
        }));
      }

    case SET_NEW_MODULE_NAME:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            newModuleName: action.newModuleName,
          })),
        }));
      }

    case SET_MODULE_TYPE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            moduleType: action.moduleType,
          })),
        }));
      }

    case SET_MODULE_ID:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            moduleId: action.moduleId,
          })),
        }));
      }

    case SET_SHOULD_SHOW_PREVIEW_OF_EXERCISE_FOR_CERT_TEST:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            shouldShowPreviewOfExerciseForCertificateTest: action.shouldShowPreviewOfExerciseForCertificateTest,
          })),
        }));
      }

    case SET_LV_VIEWER_TYPE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            lvViewerType: action.lvViewerType,
          })),
        }));
      }

    case SET_DELIVERABLE_REACHED_ACCESS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            deliverableReachedAccess: action.deliverableReachedAccess,
          })),
        }));
      }

    case SET_DELIVERABLE_REACHED_ACCESS_REASON:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            deliverableReachedAccessReason: action.deliverableReachedAccessReason,
          })),
        }));
      }

    case SET_USER_EXERCISES_RESULTS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            userExercisesResults: action.userExercisesResults,
          })),
        }));
      }

    case SET_USER_CERTIFICATE_TEST_RESULTS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            userCertificateTestResults: action.userCertificateTestResults,
          })),
        }));
      }

    case SET_USER_HAS_PASSED_TEST:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            userHasPassedTest: action.userHasPassedTest,
          })),
        }));
      }

    case SET_USER_HAS_ALL_DELIVERABLES_APPROVED:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            userHasAllDeliverablesApproved: action.userHasAllDeliverablesApproved,
          })),
        }));
      }

    case SET_MSS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            mss: action.mss,
          })),
        }));
      }

    case SET_FILTER_TEXT_GROUPS_MANAGER:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            filterGroupsText: action.filterGroupsText,
          })),
        }));
      }

    case SET_GROUPS_MANAGER_SESSION_ID:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            selectedSessionId: action.selectedSessionId,
          })),
        }));
      }

    case SET_FILTER_GROUP_TYPE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            basicGroupsSelectedFilter: action.basicGroupsSelectedFilter,
            premiumGroupsSelectedFilter: action.premiumGroupsSelectedFilter,
          })),
        }));
      }

    case IS_TOC_VISIBLE:
      {
        const doesSupportSimultaneouslyOpenDiscussionsAndToC = PlatformUtils.doesSupportSimultaneouslyOpenDiscussionsAndToC();
        if (doesSupportSimultaneouslyOpenDiscussionsAndToC) {
          return state.merge(fromJS({
            videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
              isTocVisible: action.isTocVisible,
            })),
          }));
        } else {
          return state.merge(fromJS({
            videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
              isTocVisible: action.isTocVisible,
              discussionsVisible: action.discussionsVisible && state.get('videoTimingInformation').get("discussionsReady"),
            })),
          }));
        }

      }

    case SET_DISCUSSION_VISIBLE:
      {
        const doesSupportSimultaneouslyOpenDiscussionsAndToC = PlatformUtils.doesSupportSimultaneouslyOpenDiscussionsAndToC();
        if (doesSupportSimultaneouslyOpenDiscussionsAndToC) {
          const newVisible = action.discussionsVisible && state.get('videoTimingInformation').get("discussionsReady");
          if (action.isTocVisible != null) {
            return state.merge(fromJS({
              videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
                discussionsVisible: newVisible,
              })),
            }));
          } else {
            return state.merge(fromJS({
              videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
                discussionsVisible: newVisible,
              })),
            }));
          }
        } else {
          const newVisible = action.discussionsVisible && state.get('videoTimingInformation').get("discussionsReady");
          if (action.isTocVisible != null) {
            return state.merge(fromJS({
              videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
                discussionsVisible: newVisible,
                isTocVisible: action.isTocVisible,
              })),
            }));
          } else {
            return state.merge(fromJS({
              videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
                discussionsVisible: newVisible,
              })),
            }));
          }
        }

      }

    case SET_DISCUSSION_READY:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            discussionsReady: action.discussionsReady,
          })),
        }));
      }

    case SET_SHOULD_DISPLAY_USER_OPTIONS_INSTEAD_OF_DISCUSSIONS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            shouldDisplayUserOptionsInsteadOfDiscussions: action.shouldDisplayUserOptionsInsteadOfDiscussions,
          })),
        }));
      }

    case SET_CALENDAR_EVENTS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            calendarEvents: action.calendarEvents,
          })),
        }));
      }


    case SET_DISCUSSION_WIDTH:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            discussionsWidth: action.discussionsWidth,
          })),
        }));
      }

    case IS_DISCUSSION_BEING_DRAGGED:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isDiscussionsBeingDraggedValue: action.isDiscussionsBeingDraggedValue,
          })),
        }));
      }


    case ARE_MICROTRANSACTIONS_ENABLED:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            areMicrotransactionsEnabled: action.areMicrotransactionsEnabled,
          })),
        }));
      }


    case SET_USER_PROGRESS_REDUX:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            userProgress: action.userProgress,
          })),
        }));
      }


    case SET_GROUPS_FOR_USER:
      {
        if(action.groupsForUser?.groups?.length){
          return state.merge(fromJS({
            videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
              groupsForUser: action.groupsForUser,
            })),
          }));
        } else {
          return state.merge(fromJS({
            videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
              groupsForUser: action.groupsForUser,
              wereGroupsForUserPrepared: true,
            })),
          }));
        }
      }

    case SET_WERE_GROUPS_FOR_USER_PREPARED:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            wereGroupsForUserPrepared: action.wereGroupsForUserPrepared,
          })),
        }));
      }

    case SET_USER_SUBMISSIONS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            userSubmissions: action.userSubmissions,
          })),
        }));
      }

    case SET_MENTORUI_USER_DATA:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            mentorUIUserData: action.mentorUIUserData,
          })),
        }));
      }

    case SET_CURRENT_USER_SUBMISSION_STATUS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            currentUserSubmissionStatus: action.currentUserSubmissionStatus,
          })),
        }));
      }

    case FORCE_CHECK_ACHIEVEMENT:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            forceCheckAchievementBoolean: action.forceCheckAchievementBoolean,
          })),
        }));
      }


    case SET_DELIVERABLE_DETAILS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            deliverableDetails: action.deliverableDetails,
          })),
        }));
      }

    case SET_ACTIVE_USER_GROUP:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            activeUserGroup: action.activeUserGroup,
          })),
        }));
      }

    case SET_IS_INITIAL_ACTIVE_GROUP_SET:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isInitialActiveGroupSet: action.isInitialActiveGroupSet,
          })),
        }));
      }

    case SET_IS_MENTOR_FOR_THIS_COURSE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isMentorForThisCourse: action.isMentorForThisCourse,
          })),
        }));
      }

    case SET_WILL_PAGE_BE_RELOADED:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            pageWillBeReloaded: action.pageWillBeReloaded,
          })),
        }));
      }

    case IS_WELCOME_TO_NEW_LP_MODAL_SHOWN:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isWelcomeToNewLpModalShown: action.isWelcomeToNewLpModalShown,
          })),
        }));
      }

    case SHOULD_REDIRECT_TO_PROFILE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            shouldForceOpenProfile: action.shouldForceOpenProfile,
            callbackRedirectAfterProfile: action.callbackRedirectAfterProfile,
          })),
        }));
      }

    case SHOW_PROFILE_MODAL:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            showProfileModal: action.showProfileModal,
          })),
        }));
      }

    case SET_IS_DELIVERABLES_COMPLETED:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isDeliverablesCompleted: action.isDeliverablesCompleted,
          })),
        }));
      }

    case SET_LICENSE_TIER:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            licenseTier: action.licenseTier,
          })),
        }));
      }

    case SET_NUMBER_OF_LP_USERS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            numberOfLpUsers: action.numberOfLpUsers,
          })),
        }));
      }

    case SET_SKILL_DOMAIN_POOL:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            skillDomainPool: action.skillDomainPool,
          })),
        }));
      }

    case SET_IS_IDLE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isIdle: action.isIdle,
          })),
        }));
      }

    case SET_SISTER_OFFERINGS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            sisterLicenses: action.sisterLicenses,
          })),
        }));
      }

    case SET_HAS_STARTED_LP_SISTER_OFFERINGS:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            hasSisterLicensesStarted: action.hasSisterLicensesStarted,
          })),
        }));
      }

    case SET_SISTER_LICENSES_START_DATE:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            sisterLicensesStartedDate: action.sisterLicensesStartedDate,
          })),
        }));
      }

    case SET_WINDOW_VISIBILITY:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            windowVisibility: action.windowVisibility,
          })),
        }));
      }

    case SET_IS_VIDEO_CURRENTLY_PLAYING:
      {
        return state.merge(fromJS({
          videoTimingInformation: state.get('videoTimingInformation').merge(fromJS({
            isVideoCurrentlyPlaying: action.isVideoCurrentlyPlaying,
          })),
        }));
      }

    default:
      return state;
  }
}


export default inputTimeReducer;
